const SEND_INVITATION_RESPONSE = {
  OperationResult: 'OperationResult',
  TokenError: 'TokenError',
};

export default SEND_INVITATION_RESPONSE;
